export default "__VITE_ASSET__DNw_E6SN__"